module.exports = __webpack_public_path__ + "img/blackcanvas-sakura-1.71056bd8.png";